import React from "react";
import { Outlet } from "react-router-dom";
import { ThemeProvider } from "../provider/ThemeProvider";

export default function AuthLayout() {
  return (
    <ThemeProvider attribute="class" forcedTheme="light" disableTransitionOnChange>
      <div className="relative">
        <Outlet />
      </div>
    </ThemeProvider>
  );
}
